import React, {PropTypes} from 'react';
import * as userCreationText from '../../../constants/userCreationText';
import {Link} from 'react-router';
import * as PathConstants from '../../../constants/pathConstants';

const EmailValidationInformation = ({pageNumber, pageActive}) => {
	return(
    <div className="panel" id="email-validation" hidden={pageNumber != pageActive}>
      <div>
        <h2>
          {userCreationText.confirmAccountCreation}
        </h2>
      </div>
      <div className="mobile-border-container">
        <div>
          <div>
            <h3>Thank you for registering.</h3>
            <p>Your account registration for the OSHA Injury Tracking Application is complete. You will also receive an email confirming your registration.</p>
            <p>If you experience any issues while logging in or using the application, contact us using the {}
              <Link to={PathConstants.pathToHelpRequest}>Help Request Form</Link>.
            </p>
            <p>
            If you are assuming admin roles for existing establishments, visit our Bulk Transfer Page.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

EmailValidationInformation.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  pageActive: PropTypes.number.isRequired
};

export default EmailValidationInformation;



/** WEBPACK FOOTER **
 ** ./src/components/account/createAccount/EmailValidationInformation.js
 **/